<div class="manual-submission-dialog">
    @if (loading) {
    <div class="dialog-spinner-overlay">
        <mat-spinner diameter="60" color="accent"></mat-spinner>
    </div>
    }
    <h2 mat-dialog-title><b>{{manualSubmissionTitle}}</b></h2>
    <div>
        <mat-dialog-content>
            <div class="manual-search-container">
                @if (!foundSubmission) {
                <form>
                    <mat-form-field class="manual-search">
                        <mat-label>{{manualSubmissionLabel}}</mat-label>
                        <input #input type="text" [placeholder]="manualSubmissionPlaceholder"
                            [formControl]="serialNumber" matInput>

                    </mat-form-field>
                    @if (serialNumber.invalid) {
                    <mat-error class="warning">{{errorMessage()}}</mat-error>
                    }
                </form>
                } @else {
                <p>
                    {{foundSubmission.longSerialNumber}} already has a submission.
                </p>
                <p class="submsg">
                    Click Cancel to enter a different serial number or OK to proceed to the submission.
                </p>
                }
            </div>
        </mat-dialog-content>
        <mat-dialog-actions>
            @if (!foundSubmission) {
            <button mat-button (click)="onCancel()" class="">{{ cancelButtonText }}</button>
            <button mat-button cdkFocusInitial (click)="onConfirm()" class="create-btn"
                [ngClass]="{ 'disabled': serialNumber.invalid || loading}" [disabled]="serialNumber.invalid || loading">
                {{ createButtonText }}
            </button>
            } @else {
            <button mat-button (click)="this.foundSubmission = null" class="">{{ cancelButtonText }}</button>
            <button mat-button cdkFocusInitial (click)="onNavigateToSubmission()" class="create-btn"
                [ngClass]="{ 'disabled': serialNumber.invalid || loading}" [disabled]="serialNumber.invalid || loading">
                Ok
            </button>

            }
        </mat-dialog-actions>
    </div>
</div>